import React from 'react'
import { Box, ButtonPrimaryWithArrow, Typography } from '@creditas-ui/react'
import { Routes } from 'config/routes'
import { ModalBanner } from 'shared/ui/ModalBanner/ModalBanner'
import { NotificationIds } from 'notifications/domain/NotificationsIds'
import { ContainerImage } from './HomeFinancingSimulation.styles'

const HomeFinancingSimulation = ({ isOpen, closeModal, goTo }) => {
  return (
    <ModalBanner
      isOpen={isOpen.simulation}
      closeModal={() => closeModal(NotificationIds.HomeFinancingSimulation)}
      title="O portal Creditas está ainda mais completo 🤩"
    >
      <Box display="flex" justifyContent="space-between" spaceX="10px">
        <Box width="50%" pt="18px">
          <ContainerImage />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width="50%"
          pr="49px"
          pt="47px"
        >
          <Box
            bg="neutral.0"
            borderRadius="16px"
            width="159px"
            textAlign="center"
          >
            <Typography
              color="neutral.80"
              variant="bodyXsRegular"
              p="3px 8px 3px 8px"
            >
              Financiamento de Imóvel
            </Typography>
          </Box>
          <Typography variant="bodyLgRegular" pt="24px" color="neutral.100">
            Amplie seu leque de produtos e surpreenda seus clientes:
          </Typography>
          <Typography
            variant="bodySmLight"
            pt="16px"
            pb="40px"
            color="neutral.90"
          >
            Simule financiamentos imobiliários em todos os principais bancos de
            uma só vez e envie um comparativo completo!
          </Typography>
          <ButtonPrimaryWithArrow onClick={() => goTo(Routes.Simulator)}>
            Faça uma simulação
          </ButtonPrimaryWithArrow>
        </Box>
      </Box>
    </ModalBanner>
  )
}

export { HomeFinancingSimulation }
